import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../shared.module';
import { HomepageRoutingModule } from './homepage-routing.module';
import { MarketingComponent } from './marketing/marketing.component';
import { AddCoinComponent } from './add-coin/add-coin.component';
import { ViewCoinComponent } from './view-coin/view-coin.component';
import { TermsComponent } from './terms/terms.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { CountdownModule } from 'ngx-countdown';
import { ContactPageComponent } from './contact-page/contact-page.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { AdvertisingComponent } from './advertising/advertising.component';

@NgModule({
  declarations: [MarketingComponent, AddCoinComponent, ViewCoinComponent, TermsComponent, PrivacyComponent, ContactPageComponent, AdvertisingComponent],
    imports: [
        CommonModule,
        HomepageRoutingModule,
        SharedModule,
        CountdownModule,
        LazyLoadImageModule
    ]
})
export class HomepageModule { }
